<app-global-info
  icon="mdi-alert-circle-outline"
  [title]="'fatal-error.title' | translate"
  [description]="'fatal-error.text' | translate"
  [showButton]="true"
  [buttonText]="'fatal-error.actions.try-again' | translate"
  (clicked)="reload()"
></app-global-info>
